/* eslint-disable no-unused-vars */
import * as THREE from 'three';
import BaseMesh from '../BaseMesh.js';

const getSize = (props) => {
  const { radius, heatMapData } = props;
  let minX = Number.MAX_SAFE_INTEGER;
  let maxX = -Number.MAX_SAFE_INTEGER;
  let minY = Number.MAX_SAFE_INTEGER;
  let maxY = -Number.MAX_SAFE_INTEGER;
  heatMapData.forEach((point) => {
    minX = Math.min(minX, point.x);
    maxX = Math.max(maxX, point.x);
    minY = Math.min(minY, point.y);
    maxY = Math.max(maxY, point.y);
  });
  const width = maxX - minX + radius * 2;
  const height = maxY - minY + radius * 2;
  return { width, height };
};

const getMaxMin = (props) => {
  const { heatMapData } = props;
  let min = Number.MAX_SAFE_INTEGER;
  let max = -Number.MAX_SAFE_INTEGER;
  heatMapData.forEach((point) => {
    min = Math.min(min, point.value);
    max = Math.max(max, point.value);
  });
  return { max, min };
};

const getCenter = (props) => {
  const { heatMapData } = props;
  let minX = Number.MAX_SAFE_INTEGER;
  let maxX = -Number.MAX_SAFE_INTEGER;
  let minY = Number.MAX_SAFE_INTEGER;
  let maxY = -Number.MAX_SAFE_INTEGER;
  heatMapData.forEach((point) => {
    minX = Math.min(minX, point.x);
    maxX = Math.max(maxX, point.x);
    minY = Math.min(minY, point.y);
    maxY = Math.max(maxY, point.y);
  });
  return [(minX + maxX) / 2, (minY + maxY) / 2, 0];
};

// 点的转换：世界坐标系转为工件坐标系
const pointsWorldToLocal = (pointsWorld) => {
  let minX = Number.MAX_SAFE_INTEGER;
  let minY = Number.MAX_SAFE_INTEGER;
  pointsWorld.forEach((point) => {
    minX = Math.min(minX, point.x);
    minY = Math.min(minY, point.y);
  });
  const pointsLocal = JSON.parse(JSON.stringify(pointsWorld));
  pointsLocal.forEach((point) => {
    point.x -= minX;
    point.y -= minY;
  });
  return pointsLocal;
};

// 点的转换：three 坐标系转为 canvas 坐标系; 两个坐标系成镜像关系
// 还需要算上，x，y 偏移量：radius * 2
const pointsThreeToCanvas = (pointsThree, radius) => {
  let minY = Number.MAX_SAFE_INTEGER;
  let maxY = -Number.MAX_SAFE_INTEGER;
  pointsThree.forEach((point) => {
    minY = Math.min(minY, point.y);
    maxY = Math.max(maxY, point.y);
  });
  const height = maxY - minY;

  const pointsCanvas = JSON.parse(JSON.stringify(pointsThree));
  pointsCanvas.forEach((point) => {
    point.y = height - point.y + radius;
    point.x += radius;
  });
  return pointsCanvas;
};

class Index extends BaseMesh {
  constructor(data) {
    super(data);
    this._draw();
  }

  _draw() {
    const { radius, colorStops, heatMapData } = this.props;
    // set this.position
    const center = getCenter(this.props);
    this.position.set(center[0], center[1], center[2]);

    // 世界坐标，转为工件坐标
    const pointsLocal = pointsWorldToLocal(this.props.heatMapData);
    const pointsCanvas = pointsThreeToCanvas(pointsLocal, radius);

    const { width, height } = getSize(this.props);
    const { max, min } = getMaxMin(this.props);

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');

    pointsCanvas.forEach(point => {
      let { x, y, value } = point;
      context.beginPath();
      context.arc(x, y, radius, 0, 2 * Math.PI);
      context.closePath();

      // 创建渐变色: r,g,b取值比较自由，我们只关注alpha的数值
      let radialGradient = context.createRadialGradient(x, y, 0, x, y, radius);
      // 添加一个由偏移值和颜色值指定的断点到渐变
      // radialGradient.addColorStop(1.0, "#FF000000");
      colorStops.forEach(({ offset, color }) => {
        radialGradient.addColorStop(offset, color);
      });
      context.fillStyle = radialGradient;

      // 设置globalAlpha: 需注意取值需规范在0-1之间
      let globalAlpha = (value - min) / (max - min);
      context.globalAlpha = Math.max(Math.min(globalAlpha, 1), 0);

      // 填充颜色
      context.fill();
    });

    const canvasTexture = new THREE.CanvasTexture(canvas);
    canvasTexture.needsUpdate = true;

    this.geometry = new THREE.PlaneGeometry(width, height);
    this.material = new THREE.MeshBasicMaterial({
      map: canvasTexture,
      side: THREE.FrontSide,
      transparent: true,
      depthTest: false,
      opacity: 1,
      // color: new THREE.Color(0xff00ff)
    });
  }

  updateProps(key, value) {
    super.updateProps(key, value);
    switch (key) {
      case 'radius':
        break;
      case 'colorStops':
        break;
      case 'heatMapData':
        break;
    }
    this._draw();
  }

  setProps(props) {
    super.setProps(props);
    this._draw();
  }
}

export default Index;
